import { styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        flex: 1;
    `,
};
